import { axios } from "~/plugins/request"

export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {
    findEnrollmentGuideByIdPage({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findEnrollmentGuideByIdPage`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    insert({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/insert`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    update({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/update`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    delete({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/delete`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    //艺考专业管理

    //列表
    getArtSpeciality({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`speciality/findAll`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    insertAndUpdateArtSpeciality({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`speciality/save`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    delArtSpeciality({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`speciality/deleteSpecialityinfoByID`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}
